import { useContext } from 'react';
import { ModeContext } from '@/providers/modeContext';

export function useMode() {
  const ctx = useContext(ModeContext);
  if (!ctx) {
    throw new Error('useMode deve ser usado dentro de <ModeProvider>.');
  }
  return ctx;
}
